import { useInjectQueryParamsFromStorage } from '../components/usePersistentQueryParams'

export default function InjectQueryParams() {
  useInjectQueryParamsFromStorage()

  return null
}
